import {
  delCore,
  fetchWithAuth,
  getCore,
  postCore,
  putCore,
} from "../../utils/httpInterceptor";

const coreBaseUrl =
  process.env.REACT_APP_CORE_BACKEND_URL || process.env.REACT_APP_LOAD_PAGE_URL;

class RolePermissionService {
  constructor(tenantId) {
    this.basePath = `/api/tenants/${tenantId}/roles`;
  }

  listRoles() {
    return getCore(this.basePath);
  }

  createRole(payload) {
    return postCore(this.basePath, payload);
  }

  updateRole(roleId, payload) {
    return putCore(`${this.basePath}/${roleId}`, payload);
  }

  deleteRole(roleId) {
    return delCore(`${this.basePath}/${roleId}`);
  }

  catalog() {
    return getCore(`${this.basePath}/catalog`);
  }

  rolePermissions(roleId) {
    return getCore(`${this.basePath}/${roleId}/permissions`);
  }

  updatePermissions(roleId, permissions) {
    return putCore(`${this.basePath}/${roleId}/permissions`, permissions);
  }

  users() {
    return getCore(`${this.basePath}/users`);
  }

  updateUserRoles(userId, roleIds) {
    return putCore(`${this.basePath}/users/${userId}`, { roleIds });
  }

  async exportFlyway() {
    const response = await fetchWithAuth(`${this.basePath}/export-flyway`, {
      baseUrl: coreBaseUrl,
      method: "POST",
    });
    const blob = await response.blob();
    const disposition = response.headers.get("content-disposition") || "";
    const match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      || disposition.match(/filename="?([^";]+)"?/i);
    const fileName = match
      ? decodeURIComponent(match[1])
      : `V${new Date().toISOString().replace(/\D/g, "").slice(0, 14)}__roles_permissions.sql`;
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}

export default RolePermissionService;
